<app-secondary-popup
  [title]="title"
  [isActionButtonsAvailable]="areActionButtonsAvailable()"
  [primaryActionName]="primaryAction"
  [secondaryActionName]="secondaryAction"
  [hideSecondaryButton]="hideSecondaryButton"
  [class.disable-primary]="
    primaryAction === 'Save' && hasApprovedAmountErrors()
  "
  (primaryAction)="primaryActionClicked()"
  (secondaryAction)="secondaryActionClicked()"
  (popupClosed)="closePopup($event)"
>
  @if (
    showRecordVisibilityControl &&
    recordDetails &&
    recordDetails.visibility_mode &&
    recordDetails.visibility_mode !== recordVisibilityModes.Public
  ) {
    <div slot="title" class="visibility-mode-indicator has-tooltip">
      @if (recordDetails.visibility_mode === recordVisibilityModes.Private) {
        <app-svg-icon
          [iconName]="'private-lock.svg'"
          [width]="'18px'"
          [height]="'18px'"
          [style.fill]="'#fff'"
        ></app-svg-icon>
      } @else if (
        recordDetails.visibility_mode === recordVisibilityModes.Restricted
      ) {
        <app-svg-icon
          [iconName]="'restricted-users.svg'"
          [width]="'18px'"
          [height]="'18px'"
          [style.fill]="'#fff'"
        ></app-svg-icon>
      }
      <div class="tooltip" role="tooltip">
        <div class="arrow-up"></div>
        <span>
          {{
            recordDetails.visibility_mode === recordVisibilityModes.Private
              ? "Private"
              : "Restricted"
          }}
        </span>
      </div>
    </div>
  }

  @if (recordDetails) {
    <div class="container" [class.user-dropdown-active]="showUsersDropdown">
      <div
        class="assigned-wrapper"
        [class.assigned]="recordDetails.assigned_to"
        [class.no-access]="!recordDetails.has_access"
      >
        @if (!recordDetails.has_access) {
          <div class="no-access-overlay">
            <div class="no-access-message">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="12"
                height="12"
              >
                <path
                  d="M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                />
              </svg>
              <span
                >You do not have access to perform actions on this record</span
              >
            </div>
          </div>
        }
        <div class="left-section">
          <div class="assignment-actions" id="tour-toggle-assign-btn">
            @if (recordDetails.assigned_to) {
              <button
                type="button"
                class="action-btn unassign-btn"
                [class.disabled]="hideAssignToMe"
                (click)="hideAssignToMe ? null : toggleAssignedStatus()"
                [title]="
                  'Unassign from ' +
                  (this.loggedInUserInfo?.connection_display_name ||
                    this.loggedInUserInfo?.connection)
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <!-- Filled circle background -->
                  <circle cx="12" cy="12" r="9" fill="currentColor" />
                  <!-- Checkmark inside the circle -->
                  <path
                    d="M8 12l3 3 5-5"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    fill="none"
                  />
                </svg>
                <span class="button-text">
                  @if (recordDetails.assigned_to) {
                    Assigned to
                    {{
                      this.loggedInUserInfo?.connection_display_name ||
                        this.loggedInUserInfo?.connection
                    }}
                  } @else {
                    Assigned
                  }
                </span>
              </button>
            } @else {
              <button
                type="button"
                class="action-btn assign-btn"
                [class.disabled]="
                  hideAssignToMe ||
                  (recordDetails.lead_quota &&
                    recordDetails.lead_quota.lead_count >=
                      recordDetails.lead_quota.quota)
                "
                (mouseenter)="onAssignButtonHover(true)"
                (mouseleave)="onAssignButtonHover(false)"
                (click)="
                  hideAssignToMe ||
                  (recordDetails.lead_quota &&
                    recordDetails.lead_quota.lead_count >=
                      recordDetails.lead_quota.quota)
                    ? null
                    : toggleAssignedStatus()
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <!-- Empty circle for unassigned state -->
                  <circle
                    cx="12"
                    cy="12"
                    r="7"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                  />
                </svg>
                <span class="button-text">Assign to me</span>
              </button>
            }
          </div>
          <div class="assignment-section">
            <!-- This section is now empty as badges are removed -->
          </div>
        </div>

        <div class="right-section">
          <ng-container #leadAttributesToggleContainer></ng-container>
          @if (!isEditClicked) {
            <!-- All Action Icons (no dropdown needed) -->
            <div class="primary-actions">
              <a
                id="tour-view-leads-history"
                href="javascript:void(0)"
                (click)="toggleLeadsHistory()"
                title="View Leads History"
                [class.active]="showLeadsHistoryInline"
                class="icon-btn"
              >
                @if (isLoadingLeadsHistory) {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    viewBox="0 0 512 512"
                    class="spin"
                  >
                    <path
                      d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                    />
                  </svg>
                } @else {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
                    />
                  </svg>
                }
              </a>

              @if (canShowScore && hasViewOpportunityIndicatorPermission) {
                <a
                  id="tour-view-opportunity-indicator"
                  href="javascript:void(0)"
                  (click)="openScoreDataSourcePopup()"
                  title="View Opportunity Indicator"
                  [class.active]="showScore"
                  class="icon-btn"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width="18px"
                    height="18px"
                  >
                    <path
                      d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                    />
                  </svg>
                </a>
              }

              @if (recordDetails.assigned_to || company.source === "SME") {
                @if (
                  isAllowedForConnection() &&
                  recordDetails.last_outreach_date &&
                  !isLoanFormFilled() &&
                  recordDetails.assigned_to &&
                  recordDetails.source_type !== "PUBLIC"
                ) {
                  <a
                    href="javascript:void(0)"
                    (click)="
                      showSendOutreachEmailConfirm = true;
                      selectedOutreachFormType = 'GENERIC_S2'
                    "
                    title="Send Outreach Email"
                    class="icon-btn"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width="18px"
                      height="18px"
                    >
                      <path
                        d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
                      />
                    </svg>
                  </a>
                }

                <a
                  id="tour-view-notes"
                  href="javascript:void(0)"
                  (click)="showNotes = !showNotes"
                  title="View Notes"
                  [class.active]="showNotes"
                  class="icon-btn"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    viewBox="0 0 640 640"
                  >
                    <path
                      d="M128.1 64C92.8 64 64.1 92.7 64.1 128L64.1 512C64.1 547.3 92.8 576 128.1 576L274.3 576L285.2 521.5C289.5 499.8 300.2 479.9 315.8 464.3L448 332.1L448 234.6C448 217.6 441.3 201.3 429.3 189.3L322.8 82.7C310.8 70.7 294.5 64 277.6 64L128.1 64zM389.6 240L296.1 240C282.8 240 272.1 229.3 272.1 216L272.1 122.5L389.6 240zM332.3 530.9L320.4 590.5C320.2 591.4 320.1 592.4 320.1 593.4C320.1 601.4 326.6 608 334.7 608C335.7 608 336.6 607.9 337.6 607.7L397.2 595.8C409.6 593.3 421 587.2 429.9 578.3L548.8 459.4L468.8 379.4L349.9 498.3C341 507.2 334.9 518.6 332.4 531zM600.1 407.9C622.2 385.8 622.2 350 600.1 327.9C578 305.8 542.2 305.8 520.1 327.9L491.3 356.7L571.3 436.7L600.1 407.9z"
                    />
                  </svg>
                </a>
                <a
                  id="tour-export-to-pdf"
                  href="javascript:void(0)"
                  (click)="downloadPDF()"
                  title="Export to PDF"
                  [class.disabled]="isDownloadingPdf"
                  class="icon-btn"
                >
                  @if (isDownloadingPdf) {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18px"
                      height="18px"
                      viewBox="0 0 512 512"
                      class="spin"
                    >
                      <path
                        d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                      />
                    </svg>
                  } @else {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18px"
                      height="18px"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                      />
                    </svg>
                  }
                </a>
              }

              @if (showRecordVisibilityControl) {
                <a
                  id="tour-visibility-mode"
                  href="javascript:void(0)"
                  (click)="openVisibilityModal()"
                  title="Change Visibility Mode"
                  class="icon-btn"
                >
                  @if (
                    recordDetails.visibility_mode ===
                    recordVisibilityModes.Private
                  ) {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18px"
                      height="18px"
                      viewBox="0 0 448 512"
                    >
                      <path
                        d="M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 16 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l16 0z"
                      />
                    </svg>
                  } @else if (
                    recordDetails.visibility_mode ===
                    recordVisibilityModes.Restricted
                  ) {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18px"
                      height="18px"
                      viewBox="0 0 640 512"
                    >
                      <path
                        d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"
                      />
                    </svg>
                  } @else {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18px"
                      height="18px"
                      viewBox="0 0 576 512"
                    >
                      <path
                        d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
                      />
                    </svg>
                  }
                </a>
              }

              @if (company.source !== "VLF") {
                <a
                  id="tour-share-details"
                  href="javascript:void(0)"
                  (click)="onShowUsersDropDown()"
                  title="Share"
                  class="icon-btn"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    viewBox="0 0 576 512"
                  >
                    <path
                      d="M352 224l-46.5 0c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8l-2.5 0c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144l80 0 0-61.3C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2l-3.7 0c-17.7 0-32-14.3-32-32l0-64zM80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96z"
                    />
                  </svg>
                </a>
              }

              @if (company.source === "SME") {
                <a
                  id="tour-view-profile"
                  href="javascript:void(0)"
                  (click)="viewProfile(company)"
                  title="View Profile"
                  class="icon-btn"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    viewBox="0 0 448 512"
                  >
                    <path
                      d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"
                    />
                  </svg>
                </a>
              }

              <a
                id="tour-report-record"
                href="javascript:void(0)"
                (click)="openReportModal()"
                title="Flag Record"
                class="icon-btn report-record-btn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18px"
                  height="18px"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
                  ></path>
                  <line x1="4" y1="22" x2="4" y2="15"></line>
                </svg>
              </a>
            </div>

            @if (showUsersDropdown) {
              <div
                class="users-list-dropdown"
                (appClickOutside)="onCloseUsersDropDown()"
              >
                <div class="search-users">
                  <div class="selected-tags">
                    @for (
                      connection of getSelectedConnections();
                      track $index
                    ) {
                      <div class="tag">
                        {{ connection.displayName }}
                        <a
                          href="javascript:void(0)"
                          class="remove-tag"
                          (click)="removeConnection(connection.connectionName)"
                        >
                          <svg
                            width="10px"
                            height="10px"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                            />
                          </svg>
                        </a>
                      </div>
                    }
                    @for (user of getSelectedUsers(); track $index) {
                      <div class="tag">
                        {{ user }}
                        <a
                          href="javascript:void(0)"
                          class="remove-tag"
                          (click)="removeUser(user)"
                        >
                          <svg
                            width="10px"
                            height="10px"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                            />
                          </svg>
                        </a>
                      </div>
                    }
                  </div>
                  <input
                    type="text"
                    placeholder="Search connections..."
                    (input)="onSearchUser()"
                  />
                </div>
                <div class="users-list">
                  <div class="users-data-list-wrapper">
                    @if (!isLoadingConnections) {
                      @for (
                        connection of availableConnections;
                        track connection.id
                      ) {
                        <div class="connection-group">
                          <div class="checkbox-section company-checkbox">
                            <!-- Expand/Collapse Icon -->
                            <label class="checkbox-container">
                              <input
                                type="checkbox"
                                [checked]="
                                  !!selectedConnections[
                                    connection.connection_name
                                  ]
                                "
                                (change)="
                                  onUsersSelection(
                                    $event,
                                    connection.connection_name,
                                    true
                                  )
                                "
                              />
                              <span class="checkmark"></span>
                            </label>
                            <div
                              class="label-text company-name"
                              [title]="connection.connection_name"
                              (click)="
                                onSelectConnection(connection);
                                $event.stopPropagation()
                              "
                              (keydown.enter)="
                                onSelectConnection(connection);
                                $event.stopPropagation()
                              "
                              tabindex="0"
                            >
                              {{
                                connection.display_name ||
                                  connection.connection_name
                              }}
                            </div>

                            <button
                              type="button"
                              class="expand-icon-btn"
                              (click)="
                                onSelectConnection(connection);
                                $event.stopPropagation()
                              "
                              [class.expanded]="
                                selectedConnection?.id === connection.id
                              "
                              aria-label="Toggle connection users"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                              >
                                <path
                                  d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
                                />
                              </svg>
                            </button>
                          </div>

                          @if (selectedConnection?.id === connection.id) {
                            <div class="connection-users">
                              <div
                                class="search-users-wrapper"
                                (click)="$event.stopPropagation()"
                                (keydown)="$event.stopPropagation()"
                                tabindex="-1"
                              >
                                <input
                                  type="text"
                                  placeholder="Search users..."
                                  class="user-search-input"
                                  [value]="userSearchKey"
                                  (input)="onSearchConnectionUser($event)"
                                />
                              </div>
                              @if (isLoadingConnectionUsers) {
                                <div class="no-results">Loading users...</div>
                              } @else {
                                @for (
                                  user of availableUsers;
                                  track user.username
                                ) {
                                  <div
                                    class="checkbox-section"
                                    [class.disabled]="
                                      !!selectedConnections[
                                        connection.connection_name
                                      ]
                                    "
                                  >
                                    <label class="checkbox-container">
                                      <input
                                        type="checkbox"
                                        [checked]="
                                          selectedPeopleToShare.includes(
                                            user.username
                                          ) ||
                                          selectedThroughConnections.has(
                                            user.username
                                          )
                                        "
                                        [disabled]="
                                          !!selectedConnections[
                                            connection.connection_name
                                          ]
                                        "
                                        (change)="
                                          onUsersSelection(
                                            $event,
                                            undefined,
                                            false,
                                            {
                                              username: user.username,
                                              name: user.name,
                                            }
                                          )
                                        "
                                      />
                                      <span class="checkmark"></span>
                                      <div
                                        class="label-text"
                                        [title]="user.name"
                                      >
                                        {{ user.name }}
                                      </div>
                                    </label>
                                  </div>
                                } @empty {
                                  <div class="no-results">No users found!</div>
                                }

                                @if (hasMoreUsers) {
                                  <div class="load-more-wrapper">
                                    <button
                                      class="load-more-btn"
                                      (click)="loadMoreUsers()"
                                    >
                                      Load More Users
                                    </button>
                                  </div>
                                }
                              }
                            </div>
                          }
                        </div>
                      } @empty {
                        <div class="no-results">
                          <div class="no-results-text">
                            No connections found!
                            <!-- <a
                                href="javascript:void(0)"
                                class="invite-link"
                                (click)="openInvitePopup()"
                              >
                                Click here to invite organizations
                              </a> -->
                          </div>
                        </div>
                      }

                      @if (hasMoreConnections) {
                        <div class="load-more-wrapper">
                          <button
                            class="load-more-btn"
                            [class.loading]="isLoadingMoreConnections"
                            (click)="loadMoreConnections()"
                          >
                            {{
                              isLoadingMoreConnections
                                ? "Loading..."
                                : "Load More Connections"
                            }}
                          </button>
                        </div>
                      }
                    } @else {
                      <div class="no-results">Loading connections...</div>
                    }
                  </div>
                  <div class="send-btn-wrapper">
                    <a
                      href="javascript:void(0)"
                      class="send-btn"
                      [class.disabled]="
                        !selectedPeopleToShare.length &&
                        !getSelectedConnections().length
                      "
                      (click)="shareWithSelectedPeople()"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
                        />
                      </svg>
                      Send
                    </a>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>

      @if (recordDetails.assigned_to) {
        <app-lead-pipeline-tracker
          [recordId]="recordDetails.unique_id"
          [currentStatus]="getCurrentLeadStatus()"
          [leadAttributes]="recordDetails.lead_attributes"
          [hasAccess]="recordDetails.has_access"
          [isEditClicked]="isEditClicked"
          (statusChanged)="onLeadStatusChanged($event)"
        ></app-lead-pipeline-tracker>
      }

      @if (recordDetails.assigned_to && crmStatus && recordDetails.has_access) {
        <div class="crm-section">
          <a
            href="javascript:void(0)"
            class="crm-standalone-btn"
            [class.loading]="isLoadingCRM"
            [class.disabled]="isLoadingCRM"
            title="Manage in CRM"
            (click)="openCRMRecord()"
          >
            @if (isLoadingCRM) {
              <div class="loading-text">
                <svg
                  class="spin-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                  />
                </svg>
                <span>Fetching CRM Data</span>
                <div class="loading-dots">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
              </div>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M7 7h10v10M7 17L17 7"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Manage in CRM</span>
            }
          </a>
          @if (crmError) {
            <div class="crm-error-message">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                />
              </svg>
              <span>{{ crmError }}</span>
            </div>
          }
        </div>
      }

      @if (recordDetails.last_outreach_date) {
        <div class="popup-top-meta-data">
          <div class="left-section w-100">
            <span>
              Note: This business has been contacted as part of the CDFI
              outreach program, Last reached out on
              {{ recordDetails.last_outreach_date | date: "medium" }}
            </span>
          </div>
        </div>
      }

      @if (recordDetails.public_link_details?.name) {
        <div class="popup-top-meta-data">
          <div class="left-section w-100">
            <span>
              This record was submitted via the public link
              <b
                ><i>{{ recordDetails.public_link_details?.name }}</i></b
              >
              created by
              <b>{{
                recordDetails.created_by_user?.connection?.display_name
              }}</b>
            </span>
          </div>
        </div>
      }

      <!-- Record Quota Component -->
      <app-record-quota
        [recordDetails]="recordDetails"
        [isAssignButtonHovered]="isAssignButtonHovered"
      ></app-record-quota>

      @if (showScore) {
        <app-record-scores
          [recordDetails]="recordDetails"
          [showLoanScore]="isLoanFormFilled()"
          [useCustomData]="useCustomData"
          [source]="company.source"
        ></app-record-scores>
      }

      <!-- Record Assignees Component -->
      <app-record-assignees
        [recordDetails]="recordDetails"
        [showLeadsHistoryInline]="showLeadsHistoryInline"
        [isLoadingLeadsHistory]="isLoadingLeadsHistory"
        [leadsHistory]="leadsHistory"
        [isAdminUser]="isAdminUser"
      ></app-record-assignees>

      <app-record-matched-cdfis
        [recordDetails]="recordDetails"
      ></app-record-matched-cdfis>

      <!-- Record Location Intelligence Component -->
      @if (unique_id || company.unique_id) {
        <app-record-location-intelligence
          [uniqueId]="unique_id || company.unique_id"
          (viewMoreClicked)="openArcgisPopup($event)"
        ></app-record-location-intelligence>
      }

      <!-- Record Attachments Component (Combined Lead Files & Outreach Attachments) -->
      @if (
        recordDetails.assigned_to ||
        (recordDetails.outreach_attachments &&
          recordDetails.outreach_attachments.length > 0)
      ) {
        <app-record-attachments
          [recordUniqueId]="
            recordDetails.assigned_to ? unique_id || company.unique_id : null
          "
          [assignedConnections]="recordDetails.assignees || []"
          [outreachAttachments]="recordDetails.outreach_attachments || []"
          [businessFiles]="recordDetails.business_files || []"
        ></app-record-attachments>
      }

      <div #pdfcontent>
        @if (hasDataAxlePermission) {
          <app-record-cache
            [company]="company"
            [recordDetails]="recordDetails"
            (refreshInfoClicked)="refreshInfo($event)"
          >
          </app-record-cache>
        }

        <div class="popup-data-wrapper">
          @if (recordDetails.assigned_to) {
            <app-record-lead-info
              [recordId]="recordDetails.unique_id"
              [leadAttributes]="recordDetails.lead_attributes"
              [isEditClicked]="isEditClicked"
              [crmStatus]="crmStatus"
              [source]="recordDetails.source_type"
              (leadStatusUpdated)="onLeadInfoStatusUpdated($event)"
            ></app-record-lead-info>
          }
          @for (group of getGroupedProperties(); track group.group) {
            @if (!shouldHideGroup(group)) {
              <div class="property-group-section" id="tour-lead-info">
                @if (group.group) {
                  <div class="section-header">
                    <h4>{{ group.group }}</h4>
                  </div>
                } @else {
                  <div class="section-header">
                    <h4>Basic Information</h4>
                  </div>
                }
                <div class="group-properties">
                  @if (group.group === "Basic Information") {
                    <div
                      class="each-popup-data full-width application-summary-field"
                    >
                      <span class="label-text">Application Summary</span>

                      <div class="value">
                        @if (
                          !isEditClicked ||
                          (isEditClicked &&
                            recordDetails.source_type !== "CUSTOM")
                        ) {
                          @if (!applicationSummary) {
                            <div>-</div>
                          } @else if (!applicationSummaryExpanded) {
                            <div class="value-inline">
                              <p
                                [innerHTML]="
                                  formatLongText(
                                    applicationSummary | slice: 0 : 365
                                  )
                                "
                              ></p>

                              @if (applicationSummary.length > 365) {
                                ...<a
                                  href="javascript:void(0)"
                                  class="show-more-link"
                                  (click)="toggleApplicationSummary()"
                                >
                                  Show more
                                </a>
                              }
                            </div>
                          } @else {
                            <div class="value-inline">
                              <div
                                [innerHTML]="formatLongText(applicationSummary)"
                              ></div>

                              <a
                                href="javascript:void(0)"
                                class="show-less-link"
                                (click)="toggleApplicationSummary()"
                              >
                                Show less
                              </a>
                            </div>
                          }
                        } @else {
                          <div class="w-100">
                            <textarea
                              [ngModel]="applicationSummary ?? ''"
                              (ngModelChange)="
                                onApplicationSummaryChange($event)
                              "
                              (blur)="isDirty = true"
                              class="application-summary-textarea"
                              [class.summary-textarea-err]="
                                isDirty && !(applicationSummary ?? '').trim()
                              "
                              rows="5"
                            ></textarea>

                            @if (
                              isDirty && !(applicationSummary ?? "").trim()
                            ) {
                              <span class="summary-error-message">
                                Application summary is required
                              </span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @for (
                    property of group.properties;
                    track property.property_name
                  ) {
                    @if (!shouldHideProperty(property)) {
                      <div
                        class="each-popup-data"
                        [class.full-width]="
                          property.type === 'textarea' ||
                          property.type === 'table'
                        "
                      >
                        <span class="label-text">{{
                          getPropertyLabel(property)
                        }}</span>
                        @if (!isEditClicked) {
                          <div class="value">
                            @if (isExpandableText(property)) {
                              @if (
                                !additionalDetailsExpanded[company.unique_id]?.[
                                  property.property_name
                                ]
                              ) {
                                <div class="value-inline">
                                  <span
                                    class="reset-style"
                                    [innerHTML]="
                                      formatLongText(
                                        property.value | slice: 0 : 100
                                      )
                                    "
                                  ></span>
                                  @if (
                                    property.value &&
                                    property.value.length > 100
                                  ) {
                                    ...<a
                                      href="javascript:void(0)"
                                      class="show-more-link"
                                      (click)="
                                        toggleTextExpansion(
                                          company.unique_id,
                                          property.property_name
                                        )
                                      "
                                      >Show more</a
                                    >
                                  }
                                </div>
                              } @else {
                                <div class="value-inline">
                                  <div
                                    [innerHTML]="formatLongText(property.value)"
                                  ></div>
                                  <a
                                    href="javascript:void(0)"
                                    class="show-less-link"
                                    (click)="
                                      toggleTextExpansion(
                                        company.unique_id,
                                        property.property_name
                                      )
                                    "
                                    >Show less</a
                                  >
                                </div>
                              }
                            } @else if (property.type === "multiselect") {
                              @if (
                                property.value && property.value.length > 0
                              ) {
                                @if (isExpandableList(property)) {
                                  @if (
                                    !additionalDetailsExpanded[
                                      company.unique_id
                                    ]?.[property.property_name]
                                  ) {
                                    <div class="value-inline">
                                      <ul class="list-value">
                                        @for (
                                          item of getMultiselectDisplayValues(
                                            property
                                          ) | slice: 0 : 4;
                                          track item
                                        ) {
                                          <li>{{ item }}</li>
                                        }
                                      </ul>
                                      @if (property.value.length > 4) {
                                        <a
                                          href="javascript:void(0)"
                                          class="show-more-link"
                                          (click)="
                                            toggleTextExpansion(
                                              company.unique_id,
                                              property.property_name
                                            )
                                          "
                                          >Show
                                          {{ property.value.length - 4 }}
                                          more</a
                                        >
                                      }
                                    </div>
                                  } @else {
                                    <div class="value-inline">
                                      <ul class="list-value">
                                        @for (
                                          item of getMultiselectDisplayValues(
                                            property
                                          );
                                          track item
                                        ) {
                                          <li>{{ item }}</li>
                                        }
                                      </ul>
                                      <a
                                        href="javascript:void(0)"
                                        class="show-less-link"
                                        (click)="
                                          toggleTextExpansion(
                                            company.unique_id,
                                            property.property_name
                                          )
                                        "
                                        >Show less</a
                                      >
                                    </div>
                                  }
                                } @else {
                                  <ul class="list-value">
                                    @for (
                                      item of getMultiselectDisplayValues(
                                        property
                                      );
                                      track $index
                                    ) {
                                      <li>{{ item }}</li>
                                    }
                                  </ul>
                                }
                              } @else {
                                -
                              }
                            } @else if (property.type === "list") {
                              @if (
                                property.value && property.value.length > 0
                              ) {
                                @if (isExpandableList(property)) {
                                  @if (
                                    !additionalDetailsExpanded[
                                      company.unique_id
                                    ]?.[property.property_name]
                                  ) {
                                    <div class="value-inline">
                                      <ul class="list-value">
                                        @for (
                                          item of property.value | slice: 0 : 4;
                                          track $index
                                        ) {
                                          <li>{{ item }}</li>
                                        }
                                      </ul>
                                      @if (property.value.length > 4) {
                                        <a
                                          href="javascript:void(0)"
                                          class="show-more-link"
                                          (click)="
                                            toggleTextExpansion(
                                              company.unique_id,
                                              property.property_name
                                            )
                                          "
                                          >Show
                                          {{ property.value.length - 4 }}
                                          more</a
                                        >
                                      }
                                    </div>
                                  } @else {
                                    <div class="value-inline">
                                      <ul class="list-value">
                                        @for (
                                          item of property.value;
                                          track $index
                                        ) {
                                          <li>{{ item }}</li>
                                        }
                                      </ul>
                                      <a
                                        href="javascript:void(0)"
                                        class="show-less-link"
                                        (click)="
                                          toggleTextExpansion(
                                            company.unique_id,
                                            property.property_name
                                          )
                                        "
                                        >Show less</a
                                      >
                                    </div>
                                  }
                                } @else {
                                  <ul class="list-value">
                                    @for (
                                      item of property.value;
                                      track $index
                                    ) {
                                      <li>{{ item }}</li>
                                    }
                                  </ul>
                                }
                              }
                            } @else if (property.type === "table") {
                              @if (
                                property.value &&
                                getTableData(property.value).length > 0
                              ) {
                                <div class="table-container">
                                  <table class="property-table">
                                    <thead>
                                      <tr>
                                        @for (
                                          key of getTableHeaders(
                                            property.value
                                          );
                                          track key
                                        ) {
                                          <th>{{ formatHeaderName(key) }}</th>
                                        }
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (
                                        row of getTableData(property.value);
                                        track $index
                                      ) {
                                        <tr>
                                          @for (
                                            key of getTableHeaders(
                                              property.value
                                            );
                                            track key
                                          ) {
                                            <td
                                              [attr.data-label]="
                                                formatHeaderName(key)
                                              "
                                            >
                                              {{ getTableCellValue(row, key) }}
                                            </td>
                                          }
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              } @else {
                                -
                              }
                            } @else {
                              @if (
                                property.type === "dropdown" ||
                                property.type === "radio" ||
                                property.property === "business_industry"
                              ) {
                                {{ getDisplayValue(property) }}
                              } @else if (
                                (property.type === "number" ||
                                  property.type === "text") &&
                                property.prefix &&
                                property.value
                              ) {
                                {{ property.prefix }}{{ property.value }}
                              } @else {
                                @if (
                                  isCityProperty(property) && property.value
                                ) {
                                  {{ formatCityName(property.value) }}
                                } @else {
                                  {{ property.value || "-" }}
                                }
                              }
                            }
                          </div>
                        } @else if (isEditClicked) {
                          @if (
                            property.isEditable && !isCountryProperty(property)
                          ) {
                            <div class="editable-property">
                              <div
                                class="edit-controls"
                                [formGroup]="propertyForm"
                              >
                                @if (isDropdown(property)) {
                                  <select
                                    [formControlName]="property.property_name"
                                    (change)="
                                      onPropertyUpdate(
                                        property.property_name,
                                        $event
                                      )
                                    "
                                    [class.ng-invalid]="
                                      propertyForm.get(property.property_name)
                                        ?.invalid &&
                                      (propertyForm.get(property.property_name)
                                        ?.touched ||
                                        propertyForm.get(property.property_name)
                                          ?.dirty)
                                    "
                                  >
                                    <option value="">
                                      Select {{ property.property_name }}
                                    </option>
                                    @for (
                                      optionLabel of getOptionKeys(
                                        property.options
                                      );
                                      track optionLabel
                                    ) {
                                      <option
                                        [value]="
                                          getOptionValue(
                                            property.options,
                                            optionLabel
                                          )
                                        "
                                      >
                                        {{ optionLabel }}
                                      </option>
                                    }
                                  </select>
                                  @if (getPropertyError(property)) {
                                    <span class="error-message">
                                      {{ getPropertyError(property) }}
                                    </span>
                                  }
                                } @else if (isStateProperty(property)) {
                                  <!-- State dropdown -->
                                  <select
                                    [formControlName]="property.property_name"
                                    (change)="onStateChange($event)"
                                    [class.ng-invalid]="
                                      propertyForm.get(property.property_name)
                                        ?.invalid &&
                                      (propertyForm.get(property.property_name)
                                        ?.touched ||
                                        propertyForm.get(property.property_name)
                                          ?.dirty)
                                    "
                                  >
                                    <option
                                      value=""
                                      [selected]="
                                        !propertyForm.get(
                                          property.property_name
                                        )?.value
                                      "
                                    >
                                      Select State
                                    </option>
                                    @for (state of states; track state) {
                                      <option [value]="state.name">
                                        {{ state.name }}
                                      </option>
                                    }
                                  </select>
                                  @if (getPropertyError(property)) {
                                    <span class="error-message">
                                      {{ getPropertyError(property) }}
                                    </span>
                                  }
                                } @else if (isCountyProperty(property)) {
                                  <!-- County dropdown -->
                                  <select
                                    [formControlName]="property.property_name"
                                    (change)="onCountyChange(property, $event)"
                                    [class.ng-invalid]="
                                      propertyForm.get(property.property_name)
                                        ?.invalid &&
                                      (propertyForm.get(property.property_name)
                                        ?.touched ||
                                        propertyForm.get(property.property_name)
                                          ?.dirty)
                                    "
                                  >
                                    <option
                                      value=""
                                      [selected]="
                                        !propertyForm.get(
                                          property.property_name
                                        )?.value
                                      "
                                    >
                                      Select County
                                    </option>
                                    @for (
                                      county of availableCounties;
                                      track county
                                    ) {
                                      <option [value]="county">
                                        {{ county }}
                                      </option>
                                    }
                                  </select>
                                  @if (getPropertyError(property)) {
                                    <span class="error-message">
                                      {{ getPropertyError(property) }}
                                    </span>
                                  }
                                } @else if (isCityProperty(property)) {
                                  <!-- City dropdown -->
                                  <select
                                    [formControlName]="property.property_name"
                                    (change)="onCityChange($event)"
                                    [class.ng-invalid]="
                                      propertyForm.get(property.property_name)
                                        ?.invalid &&
                                      (propertyForm.get(property.property_name)
                                        ?.touched ||
                                        propertyForm.get(property.property_name)
                                          ?.dirty)
                                    "
                                  >
                                    <option
                                      value=""
                                      [selected]="
                                        !propertyForm.get(
                                          property.property_name
                                        )?.value
                                      "
                                    >
                                      Select City
                                    </option>

                                    @for (city of availableCities; track city) {
                                      <option [value]="city">
                                        {{ formatCityName(city) }}
                                      </option>
                                    }
                                  </select>

                                  @if (getPropertyError(property)) {
                                    <span class="error-message">
                                      {{ getPropertyError(property) }}
                                    </span>
                                  }
                                } @else if (isZipcodeProperty(property)) {
                                  <!-- Zipcode dropdown -->
                                  <select
                                    [formControlName]="property.property_name"
                                    (change)="
                                      onPropertyUpdate(
                                        property.property_name,
                                        $event
                                      )
                                    "
                                    [class.ng-invalid]="
                                      propertyForm.get(property.property_name)
                                        ?.invalid &&
                                      (propertyForm.get(property.property_name)
                                        ?.touched ||
                                        propertyForm.get(property.property_name)
                                          ?.dirty)
                                    "
                                  >
                                    <option
                                      value=""
                                      [selected]="
                                        !propertyForm.get(
                                          property.property_name
                                        )?.value
                                      "
                                    >
                                      @if (!availableZipcodes.length) {
                                        Select a City first
                                      } @else {
                                        Select Zip Code
                                      }
                                    </option>

                                    @for (zip of availableZipcodes; track zip) {
                                      <option [value]="zip">
                                        {{ zip }}
                                      </option>
                                    }
                                  </select>

                                  @if (getPropertyError(property)) {
                                    <span class="error-message">
                                      {{ getPropertyError(property) }}
                                    </span>
                                  }
                                } @else if (isMultiselect(property)) {
                                  <div
                                    class="checkbox-wrapper multiselect-wrapper"
                                  >
                                    @for (
                                      optionLabel of getOptionKeys(
                                        property.options
                                      );
                                      track optionLabel
                                    ) {
                                      <div class="checkbox-item">
                                        <label class="checkbox-container">
                                          <input
                                            type="checkbox"
                                            [checked]="
                                              isMultiselectValueSelected(
                                                property,
                                                optionLabel
                                              )
                                            "
                                            (change)="
                                              onMultiselectChange(
                                                property,
                                                optionLabel,
                                                $event
                                              )
                                            "
                                            [id]="
                                              property.property_name +
                                              '_' +
                                              optionLabel
                                            "
                                          />
                                          <span class="checkmark"></span>
                                          <span class="checkbox-label">{{
                                            optionLabel
                                          }}</span>
                                        </label>
                                      </div>
                                    }
                                  </div>
                                  @if (getPropertyError(property)) {
                                    <span class="error-message">
                                      {{ getPropertyError(property) }}
                                    </span>
                                  }
                                } @else if (property.type === "checkbox") {
                                  <div class="checkbox-wrapper">
                                    <input
                                      type="checkbox"
                                      [formControlName]="property.property_name"
                                      (change)="
                                        onPropertyUpdate(
                                          property.property_name,
                                          $event
                                        )
                                      "
                                      [id]="property.property_name"
                                    />
                                    <label [for]="property.property_name">{{
                                      property.value
                                    }}</label>
                                  </div>
                                } @else if (property.type === "radio") {
                                  <div class="radio-wrapper">
                                    @for (
                                      optionLabel of getOptionKeys(
                                        property.options
                                      );
                                      track optionLabel
                                    ) {
                                      <div class="radio-option">
                                        <input
                                          type="radio"
                                          [name]="property.property_name"
                                          [formControlName]="
                                            property.property_name
                                          "
                                          [value]="
                                            getOptionValue(
                                              property.options,
                                              optionLabel
                                            )
                                          "
                                          [id]="
                                            property.property_name +
                                            '_' +
                                            optionLabel
                                          "
                                          (change)="
                                            onPropertyUpdate(
                                              property.property_name,
                                              $event
                                            )
                                          "
                                        />
                                        <label
                                          [for]="
                                            property.property_name +
                                            '_' +
                                            optionLabel
                                          "
                                        >
                                          {{ optionLabel }}
                                        </label>
                                      </div>
                                    }
                                  </div>
                                } @else if (property.type === "table") {
                                  <!-- Editable table -->
                                  <div class="table-editor">
                                    @if (
                                      getEditableTableData(
                                        property.property_name,
                                        property.value
                                      ).length > 0
                                    ) {
                                      <div class="table-container">
                                        <table class="property-table editable">
                                          <thead>
                                            <tr>
                                              @for (
                                                key of getTableHeaders(
                                                  getEditableTableData(
                                                    property.property_name,
                                                    property.value
                                                  )
                                                );
                                                track key
                                              ) {
                                                <th>
                                                  {{ formatHeaderName(key) }}
                                                </th>
                                              }
                                              <th class="actions-column">
                                                Actions
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            @for (
                                              row of getEditableTableData(
                                                property.property_name,
                                                property.value
                                              );
                                              track rowIndex;
                                              let rowIndex = $index
                                            ) {
                                              <tr>
                                                @for (
                                                  key of getTableHeaders(
                                                    getEditableTableData(
                                                      property.property_name,
                                                      property.value
                                                    )
                                                  );
                                                  track key
                                                ) {
                                                  <td
                                                    [attr.data-label]="
                                                      formatHeaderName(key)
                                                    "
                                                  >
                                                    @if (
                                                      key.includes("percentage")
                                                    ) {
                                                      <input
                                                        type="number"
                                                        [value]="
                                                          getRawTableCellValue(
                                                            row,
                                                            key
                                                          )
                                                        "
                                                        (input)="
                                                          updateTableCell(
                                                            property.property_name,
                                                            rowIndex,
                                                            key,
                                                            $any($event.target)
                                                              .value
                                                          )
                                                        "
                                                        min="0"
                                                        max="100"
                                                      />
                                                    } @else {
                                                      <input
                                                        type="text"
                                                        [value]="
                                                          getRawTableCellValue(
                                                            row,
                                                            key
                                                          )
                                                        "
                                                        (input)="
                                                          updateTableCell(
                                                            property.property_name,
                                                            rowIndex,
                                                            key,
                                                            $any($event.target)
                                                              .value
                                                          )
                                                        "
                                                      />
                                                    }
                                                  </td>
                                                }
                                                <td
                                                  class="actions-cell"
                                                  data-label="Actions"
                                                >
                                                  <button
                                                    type="button"
                                                    class="remove-row-btn"
                                                    (click)="
                                                      removeTableRow(
                                                        property.property_name,
                                                        rowIndex
                                                      )
                                                    "
                                                    [disabled]="
                                                      getEditableTableData(
                                                        property.property_name,
                                                        property.value
                                                      ).length === 1
                                                    "
                                                    title="Remove row"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      viewBox="0 0 448 512"
                                                      width="14"
                                                      height="14"
                                                    >
                                                      <path
                                                        d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
                                                      />
                                                    </svg>
                                                  </button>
                                                </td>
                                              </tr>
                                            }
                                          </tbody>
                                        </table>
                                      </div>
                                      <button
                                        type="button"
                                        class="add-row-btn"
                                        (click)="
                                          addTableRow(
                                            property.property_name,
                                            property.value
                                          )
                                        "
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 448 512"
                                          width="14"
                                          height="14"
                                        >
                                          <path
                                            d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
                                          />
                                        </svg>
                                        Add Row
                                      </button>
                                    }
                                  </div>
                                } @else {
                                  <input
                                    [type]="
                                      property.type === 'number'
                                        ? 'text'
                                        : property.type
                                    "
                                    [formControlName]="property.property_name"
                                    [placeholder]="
                                      getNumberPlaceholder(property)
                                    "
                                    (input)="
                                      onPropertyUpdate(
                                        property.property_name,
                                        $event
                                      )
                                    "
                                    [class.ng-invalid]="
                                      propertyForm.get(property.property_name)
                                        ?.invalid &&
                                      (propertyForm.get(property.property_name)
                                        ?.touched ||
                                        propertyForm.get(property.property_name)
                                          ?.dirty)
                                    "
                                  />
                                  @if (
                                    property.property ===
                                      "lead_info::approved_loan_amount" &&
                                    getApprovedAmountError()
                                  ) {
                                    <span class="error-message">
                                      {{ getApprovedAmountError() }}
                                    </span>
                                  } @else if (getPropertyError(property)) {
                                    <span class="error-message">
                                      {{ getPropertyError(property) }}
                                    </span>
                                  }
                                }
                              </div>
                            </div>
                          } @else {
                            <div class="value">
                              @if (property.type === "multiselect") {
                                @if (
                                  property.value && property.value.length > 0
                                ) {
                                  <ul class="list-value">
                                    @for (item of property.value; track item) {
                                      <li>{{ item }}</li>
                                    }
                                  </ul>
                                } @else {
                                  -
                                }
                              } @else if (property.type === "table") {
                                @if (
                                  property.value &&
                                  getTableData(property.value).length > 0
                                ) {
                                  <div class="table-container">
                                    <table class="property-table">
                                      <thead>
                                        <tr>
                                          @for (
                                            key of getTableHeaders(
                                              property.value
                                            );
                                            track key
                                          ) {
                                            <th>
                                              {{ formatHeaderName(key) }}
                                            </th>
                                          }
                                        </tr>
                                      </thead>
                                      <tbody>
                                        @for (
                                          row of getTableData(property.value);
                                          track $index
                                        ) {
                                          <tr>
                                            @for (
                                              key of getTableHeaders(
                                                property.value
                                              );
                                              track key
                                            ) {
                                              <td
                                                [attr.data-label]="
                                                  formatHeaderName(key)
                                                "
                                              >
                                                {{
                                                  getTableCellValue(row, key)
                                                }}
                                              </td>
                                            }
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                } @else {
                                  -
                                }
                              } @else {
                                @if (
                                  property.property === "business_industry"
                                ) {
                                  {{ getDisplayValue(property) }}
                                } @else if (
                                  (property.type === "number" ||
                                    property.type === "text") &&
                                  property.prefix &&
                                  property.value
                                ) {
                                  {{ property.prefix }}{{ property.value }}
                                } @else {
                                  {{ property.value || "-" }}
                                }
                              }
                            </div>
                          }
                        }
                      </div>
                    }
                  }
                </div>
              </div>
            }
          }
        </div>
      </div>

      @if (showSendOutreachEmailConfirm) {
        <app-popup
          [heading]="'Send Outreach Email'"
          [confirmText]="'Send'"
          [cancelText]="'Cancel'"
          [popupPosition]="'absolute'"
          [isConfirmDisabled]="!isOutreachFormValid()"
          (confirmClicked)="sendOutreachEmail()"
          (cancelClicked)="cancelOutreachEmail()"
        >
          <div class="outreach-form-selection">
            <span class="form-type-header"
              >Select the type of outreach form to send:</span
            >
            <div class="form-type-options">
              @for (formType of outreachFormTypes; track formType.value) {
                <label class="form-type-option">
                  <input
                    type="radio"
                    name="outreachFormType"
                    [value]="formType.value"
                    [(ngModel)]="selectedOutreachFormType"
                  />
                  <span class="radio-custom"></span>
                  <span class="form-type-label">{{ formType.label }}</span>
                </label>
              }
            </div>
            @if (isLoanFormFilled()) {
              <p class="validation-message warning-message">
                This lead has already filled out the loan form.
              </p>
            }
            <!-- @if (!isOutreachFormValid()) {
              <p class="validation-message">
                Please select a form type to continue.
              </p>
            } -->
          </div>
        </app-popup>
      }
      @if (showUnassignPopup) {
        <app-unassign-lead-popup
          [leadName]="company.company_name"
          [leadUniqueId]="company.unique_id || unique_id || ''"
          [currentStatus]="getCurrentLeadStatus()"
          [statusNotes]="
            recordDetails.lead_attributes?.['status_notes'] ||
            company.lead_attributes?.['status_notes'] ||
            ''
          "
          [leadAttributes]="
            recordDetails.lead_attributes || company.lead_attributes
          "
          [popupPosition]="'absolute'"
          [isSubmitting]="isUnassigning"
          (confirm)="OnConfirmUnassign($event)"
          (cancel)="showUnassignPopup = false"
        ></app-unassign-lead-popup>
      }

      @if (showUnsavedChangesPopup) {
        <app-popup
          [heading]="'Are you sure you want to close?'"
          [confirmText]="'Discard'"
          [cancelText]="'Stay'"
          [popupPosition]="'absolute'"
          (confirmClicked)="confirmClose()"
          (cancelClicked)="cancelClose()"
        >
          <div class="lead-unassign-popup-content">
            You have unsaved changes
          </div>
        </app-popup>
      }

      @if (showDeletePopup) {
        <app-popup
          [heading]="'Are you sure you want to delete?'"
          [confirmText]="'Delete'"
          [cancelText]="'Cancel'"
          [popupPosition]="'absolute'"
          (confirmClicked)="confirmDelete()"
          (cancelClicked)="cancelDelete()"
        >
          <div class="lead-unassign-popup-content">
            {{ company.company_name }}
          </div>
        </app-popup>
      }

      @if (showScoreDataSourcePopup) {
        <app-popup
          [heading]="'Select Data Source for Opportunity Indicator Calculation'"
          [popupPosition]="'absolute'"
          [showFooterButtons]="false"
          [showCloseIcon]="true"
          (cancelClicked)="cancelScoreDataSource()"
        >
          <div class="score-data-source-selection" id="tour-score-data-source">
            <p class="selection-description">
              Choose the data source you want to use for calculating the
              Opportunity Indicator:
            </p>
            <div class="data-source-options">
              <label
                class="data-source-option"
                [class.selected]="useCustomData === false"
              >
                <input
                  id="tour-display-outreach-data"
                  type="radio"
                  name="scoreDataSource"
                  [value]="false"
                  [(ngModel)]="useCustomData"
                  (change)="onScoreDataSourceSelected()"
                />
                <div class="option-content">
                  <div class="option-icon">📋</div>
                  <div class="option-details">
                    <span class="option-title">Use Outreach Form Data</span>
                    <span class="option-description">
                      Calculate using the data from outreach forms
                    </span>
                  </div>
                </div>
              </label>
              <label
                class="data-source-option"
                [class.selected]="useCustomData === true"
              >
                <input
                  type="radio"
                  name="scoreDataSource"
                  [value]="true"
                  [(ngModel)]="useCustomData"
                  (change)="onScoreDataSourceSelected()"
                />
                <div class="option-content">
                  <div class="option-icon">✏️</div>
                  <div class="option-details">
                    <span class="option-title"
                      >Use Custom Manual Entry Data</span
                    >
                    <span class="option-description">
                      Calculate using the manually entered record data
                    </span>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </app-popup>
      }
    </div>
  } @else {
    @if (recordErrorMessage !== "") {
      <div class="no-records-found">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
          />
        </svg>
        <span>{{ recordErrorMessage }}</span>
      </div>
    }
  }
</app-secondary-popup>

@if (showNotes) {
  <app-record-notes
    [uniqueId]="unique_id ? unique_id : company.unique_id"
    [companyName]="title"
    (closePopup)="showNotes = false"
  ></app-record-notes>
}

@if (showVisibilityModal) {
  <app-record-visibility-popup
    [recordId]="company.unique_id"
    [recordDetails]="recordDetails"
    (close)="closeVisibilityModal()"
    (visibilityUpdated)="onVisibilityUpdated()"
  ></app-record-visibility-popup>
}

<!-- Invite Organizations Popup -->
<app-invite-popup
  [show]="showInvitePopup"
  (closePopup)="closeInvitePopup()"
></app-invite-popup>

<!-- Location Intelligence Popup -->
@if (showArcgisPopup && company) {
  <app-record-arcgis
    [latitude]="company.latitude!"
    [longitude]="company.longitude!"
    [recordName]="title"
    [uniqueId]="company.unique_id"
    [preloadedData]="preloadedArcgisData"
    (closePopup)="closeArcgisPopup()"
  ></app-record-arcgis>
}

@if (showVlfClaimModal) {
  <app-popup
    [heading]="'Confirm VLF Lead Assignment'"
    [confirmText]="'Confirm & Claim Lead'"
    [cancelText]="'Cancel'"
    [popupPosition]="'fixed'"
    (confirmClicked)="confirmClaimVLFLead()"
    (cancelClicked)="showVlfClaimModal = false"
  >
    <div class="vlf-claim-modal-body">
      <div class="vlf-modal-header">
        <div class="vlf-modal-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <div class="vlf-modal-header-text">
          <h4>7-Business-Day Funding Window</h4>
          <span>Time frame and operating rules for claimed VLF leads</span>
        </div>
      </div>

      <div class="vlf-modal-rules-box">
        <ul class="vlf-modal-rules-list">
          <li>
            <strong>7-Business-Day Funding Time Frame:</strong> Your
            organization has exactly <strong>7 business days</strong> from today
            to fund this lead and submit weekly status updates.
          </li>
          <li>
            <strong>Automated Reallocation:</strong> If not funded within 7
            business days, this lead will be automatically unassigned and
            reallocated to other regional organizations.
          </li>
          <li>
            <strong>Status Milestone Updates:</strong> Milestone notifications
            will be sent to the VLF team on status updates.
          </li>
          <li>
            <strong>Exclusive Privacy:</strong> Once claimed, your organization
            holds exclusive detail access for this lead.
          </li>
          <li>
            <strong>Final Funding Status:</strong> Once a claimed lead is
            updated to a funded status, its status cannot be reverted to a
            previous or non-funded status.
          </li>
        </ul>
      </div>

      <p class="vlf-modal-prompt">
        Are you sure you want to claim assignment for
        <strong>{{ title || "this lead" }}</strong
        >?
      </p>
    </div>
  </app-popup>
}
